import dayjs from 'dayjs'
import { isEmpty } from 'lodash'

export function LightenDarkenColor(col: string, amt: number) {
  var usePound = false

  if (col[0] == '#') {
    col = col.slice(1)
    usePound = true
  }

  var num = parseInt(col, 16)

  var r = (num >> 16) + amt

  if (r > 255) r = 255
  else if (r < 0) r = 0

  var b = ((num >> 8) & 0x00ff) + amt

  if (b > 255) b = 255
  else if (b < 0) b = 0

  var g = (num & 0x0000ff) + amt

  if (g > 255) g = 255
  else if (g < 0) g = 0

  return (usePound ? '#' : '') + (g | (b << 8) | (r << 16)).toString(16)
}

/**
 * Validate if string is a valid email format
 * @param email
 * @returns {RegExpMatchArray | null}
 */
export function validateEmail(email: string): RegExpMatchArray | null {
  return email.match(
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  )
}

export function displayFormatDate(
  date: string | Date | undefined,
  long: boolean = false
) {
  if (!date) return ''

  return long
    ? dayjs(date).format('DD-MM-YYYY hh:mm:ss A')
    : dayjs(date).format('DD MMM YYYY')
}

export function formatBytes(bytes: number, decimals = 2): string {
  if (!+bytes) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}

export function titleCase(input: string) {
  return input.replace(
    /\w\S*/g,
    (txt) => txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase()
  )
}

export function objectHasValues(givenObject: any): boolean {
  return Object.keys(givenObject).some((field) => !!givenObject[field])
}

export function formatCurrency(cents: any, hideSymbol?: boolean): string {
  const dollars = (cents / 100).toFixed(2)
  const symbol = hideSymbol ? '' : '$'

  if (dollars !== 'NaN') {
    return cents >= 0 ? `${symbol}${dollars}` : `${symbol}${dollars.slice(1)}`
  }

  return cents
}

export function displayAddress(address: any) {
  if (isEmpty(address)) {
    return ''
  }

  return `${address.unitNumber || ''}${' '}
    ${address.streetNumber}${' '}
    ${address.streetName}${' '}
    ${address.streetType}${' '}
    ${address.suburb}${' '}
    ${address.state}${' '}
    ${address.postCode}${' '}`
}

export function validateLandlinePhone(phone: string) {
  return phone.match(
    /^(?:\+?(61))? ?(?:\((?=.*\)))?(0?[2|4|3|7|8])\)? ?(\d\d(?:[- ](?=\d{3})|(?!\d\d[- ]?\d[- ]))\d\d[- ]?\d[- ]?\d{3})$/gm
  )
}

export function generateUUID(): string {
  const template = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
  return template.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export function convertBytesToGigabytes(bytes: number) {
  return bytes / 1073741824
}
